import React, { Component } from 'react';

export class ShipGroups extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        var shipGroups = this.props.shipGroups;
        return (
            <div className="shipGroups">
                {shipGroups.map(function (shipGroup, idx) {
                    return (
                        <div key={idx}>
                            {
                                shipGroup.orders
                                &&
                                <div className="shipGroup">
                                    <h1>{shipGroup.name}</h1>
                                    <table className="shipGroupOrdersTable">
                                        <th>Slot</th>
                                        <th>Tote</th>
                                        {shipGroup.orders.map(function (order, orderIdx) {
                                            return (
                                                <tr>
                                                    <td>{order.slot}</td>
                                                    <td>{order.tote}{order.priorityRank}</td>
                                                </tr>
                                            )
                                        })}
                                    </table>
                                </div>
                            }
                        </div>
                    )
                })}
                <div className="shipGroupsButtons">
                    {
                        this.props.hasRepicks
                            ?
                            <button onClick={() => this.props.putawayRepick()}>Putaway Repicks</button>
                            :
                            <button onClick={() => this.props.endSessionSummary()}>Done</button>
                    }
                </div>

            </div>
        );
    }
}
